/**
@flow strict-local
@format
*/
import { Constants as KrispyConstants } from '@krispy/layout/web';

const Constants = {
  ...KrispyConstants,
  borderRadiusSmall: 8,
};

export default Constants;
